/* eslint-disable max-len */
const ApiUrl = process.env.NEXT_PUBLIC_API_URL;

const UrlParamsReplace = (url, params = {}) => {
    let urlWithPrefix = `${ApiUrl}${url}`;
    if (params) {
        Object.keys(params).forEach((key) => (urlWithPrefix = urlWithPrefix.replace(`:${key}`, params[key])));
    }
    return urlWithPrefix;
};

export const CREATE_CONTACT = UrlParamsReplace('/contacts');

export const USER_LOGIN_URL = UrlParamsReplace('/login');
export const CREATE_COMPANY = () => UrlParamsReplace('/companies');
export const GET_ALL_COMPANIES = ({ offset, limit, role }) => UrlParamsReplace(
    '/companies?offset=:offset&limit=:limit&role=:role',
    { offset, limit, role }
);

export const GET_UPLOAD_PRE_SIGNED_URL = UrlParamsReplace('/aws/get-upload-pre-signed-url');
export const CREATE_BOND_URL = UrlParamsReplace('/bonds');
export const CREATE_USER_URL = UrlParamsReplace('/user');
export const UPDATE_USER_URL = (id) => UrlParamsReplace('/user/:id', { id });
export const CREATE_BOND_PRICE_HISTORY_URL = UrlParamsReplace('/bond-price-history');
export const RESEND_WELCOME_EMAIL = (id) => UrlParamsReplace('/resend-welcome-email/:id', { id });

export const UPDATE_COMPANY_URL = (id) => UrlParamsReplace('/companies/:id', { id });
export const GET_PAGINATED_USER_URL = (
    offset,
    limit,
    role,
    phrase
) => UrlParamsReplace('/users?offset=:offset&limit=:limit&role=:role&phrase=:phrase', {
    offset,
    limit,
    role,
    phrase
});
export const GET_PAGINATED_USER_FOR_COMPLIANCE_URL = (
    offset,
    limit,
    phrase
) => UrlParamsReplace('/compliance/users?offset=:offset&limit=:limit&phrase=:phrase', { offset, limit, phrase });
export const GET_CHAT_TOKEN_FOR_COMPLIANCE_URL = (userId) => UrlParamsReplace('/compliance/auth?userId=:userId', { userId });
export const GET_HOOTS_FOR_COMPLIANCE_URL = () => UrlParamsReplace('/compliance/hoot');
export const GET_HOOT_SEARCH_USER_FOR_COMPLIANCE_URL = ({
    phrase,
    sameCompany
}) => UrlParamsReplace('/compliance/users/search?phrase=:phrase&sameCompany=:sameCompany', { phrase, sameCompany });
export const GET_HOOT_SIGNED_BY_ID_URL = ({ id }) => UrlParamsReplace('/compliance/hoot/signed/:id', { id });

export const CREATE_SECTOR_URL = () => UrlParamsReplace('/sectors');
export const UPDATE_SECTOR_URL = (id) => UrlParamsReplace('/sectors/:id', { id });
export const GET_ALL_SECTORS_URL = (offset, limit) => UrlParamsReplace('/sectors?offset=:offset&limit=:limit', { offset, limit });
export const UPDATE_SECTOR_STATUS_URL = (id, status) => UrlParamsReplace('/sectors-status/:id?status=:status', { id, status });
export const GET_ALL_SECTORS_FOR_USER_URL = () => UrlParamsReplace('/sectors/all');

export const CREATE_BOND_LIVES_URL = UrlParamsReplace('/bond-lives');
export const CREATE_OR_UPDATE_BONDS_URL = UrlParamsReplace('/create-bonds');
export const GET_SECTORS_URL = UrlParamsReplace('/sectors');
export const UPDATE_USER_SECTORS = UrlParamsReplace('/users-sectors');

export const GET_PUSH_NOTIFICATIONS_URL = () => UrlParamsReplace('/push-notification');
export const GET_BOND_ACTIONS_URL = ({
    offset, limit, type, search
}) => UrlParamsReplace('/bond-actions?offset=:offset&limit=:limit&type=:type&search=:search', {
    offset,
    limit,
    type,
    search
});
export const GET_TRADER_COMPANIES_URL = UrlParamsReplace('/trader-company');
export const DELETE_SECTOR_URL = (id) => UrlParamsReplace('/sectors/:id', { id });
export const GET_BONDS_BY_ISIN_URL = () => UrlParamsReplace('/get-bonds-by-isins');
// export const GET_SECTORS_WITH_BONDS_URL = ({ sectorIds }) => UrlParamsReplace('/sectors-bonds?sectorIds=:sectorIds', { sectorIds });
export const GET_SECTORS_WITH_BONDS_URL = UrlParamsReplace('/sectors-bonds');

export const CREATE_BOND_SECTOR_URL = () => UrlParamsReplace('/bond-sectors');
export const GET_MATCHING_SETTINGS_URL = () => UrlParamsReplace('/matching-settings');
export const UPDATE_MATCHING_SETTINGS_URL = () => UrlParamsReplace('/matching-settings');

export const GET_USER_DETAILS_URL = () => UrlParamsReplace('/user/details');

export const SEARCH_SECTORS_URL = ({ offset, limit, phrase }) => UrlParamsReplace(
    '/sectors/search?offset=:offset&limit=:limit&phrase=:phrase',
    { offset, limit, phrase }
);
export const DELETE_BONDS_URL = UrlParamsReplace('/bonds');
export const BOND_YAS_CALCULATION_URL = (isin) => UrlParamsReplace('/bonds/yas/:isin', { isin });
export const CREATE_INDEX_HISTORY_URL = UrlParamsReplace('/indexes-histories');
export const GET_INDEX_HISTORIES = (indexId) => UrlParamsReplace('/indexes-histories/:id', { id: indexId });
export const GET_HS_BOND_INDEX_HISTORIES = ({ bondId, indexName, type }) => UrlParamsReplace(
    `/indexes-histories/bonds/:bondId/HS?${indexName ? 'indexName=:indexName' : ''}${type ? '&type=:type' : ''}`,
    { bondId, indexName, type }
);
export const GET_BASIS_BOND_INDEX_HISTORIES = ({ bondId, indexName, type }) => UrlParamsReplace(
    `/indexes-histories/bonds/:bondId/BASIS?${indexName ? 'indexName=:indexName' : ''}${type ? '&type=:type' : ''}`,
    { bondId, indexName, type }
);

export const GET_TOP_NEWS_URL = (offset, limit) => UrlParamsReplace('/top-news?offset=:offset&limit=:limit', { offset, limit });
export const CREATE_INDEX_SECURITY_URL = UrlParamsReplace('/indexes-securities');
export const CREATE_INDEX_LIVE_URL = UrlParamsReplace('/indexes-lives');

export const GET_COMPANY_NEWS_URL = (page, limit, phrase) => UrlParamsReplace(
    '/company-news?page=:page&limit=:limit&phrase=:phrase',
    { page, limit, phrase }
);

export const EDIT_USER_PROFILE_URL = (id) => UrlParamsReplace('/user/profile/:id', { id });

export const CREATE_HOLIDAY = UrlParamsReplace('/holidays');
export const UPDATE_HOLIDAY = (id) => UrlParamsReplace(`/holidays/${id}`);
export const DELETE_HOLIDAY = (id) => UrlParamsReplace(`/holidays/${id}`);
export const GET_HOLIDAYS = UrlParamsReplace('/holidays');
export const GET_CURRENCIES = UrlParamsReplace('/currencies');
export const CHECK_CURRENCY_HIDDEN = (id) => UrlParamsReplace('/currencies/:id/hidden', { id });
export const GET_CDRS = UrlParamsReplace('/cdrs');
export const CREATE_IRS_HISTORY_URL = UrlParamsReplace('/irs-histories');
export const GET_IRS_HISTORY = (id, legs, limit, conversion, page) => UrlParamsReplace(`/irs-histories/irs-bond/:id?legs=${legs}${limit ? `&limit=${limit}` : ''}${conversion ? `&conversion=${conversion}` : ''}${page ? `&page=${page}` : ''}`, { id });
export const GET_CDS_HISTORY = (id, legs) => UrlParamsReplace(`/cds-histories/:id?legs=${legs}`, { id });
export const GET_CURRENCY_HISTORY = (id, legs, spot, isFwdPoints = false, last = null) => UrlParamsReplace(`/currency-histories/:id?legs=${legs}${spot ? '&spot=1' : ''}&isFwdPoints=${isFwdPoints}${last ? '&last=2' : ''}`, { id });
export const UPDATE_USER_STATUS_URL = (id) => UrlParamsReplace('/users/:id', { id });
export const GET_HOOT_TOKEN_URL = UrlParamsReplace('/hoot/token');
export const SESSION_LOGOUT = UrlParamsReplace('/sessions/disconnect');
export const SEND_EMAIL_URL = UrlParamsReplace('/emails/trade');
export const GET_EMAIL_URL = (id) => UrlParamsReplace(`/emails/trade?id=${id}`);
export const DELETE_BONDS_PRICE_HISTORY_URL = UrlParamsReplace('/bonds/price-histories');
export const CREATE_OR_UPDATE_USER_BOND = UrlParamsReplace('/users-bonds');
export const GET_TRADE_EXCEL_URL = UrlParamsReplace('/excel/trades');
export const GET_BONDS_PRICE_HISTORY_URL = (id, limit) => UrlParamsReplace(`/bonds/:id/price-histories?${limit ? `limit=${limit}` : ''}`, { id });
export const GET_BONDS_PRICE_HISTORY_SNP_URL = (id) => UrlParamsReplace('/bond-price-histories/:id/snp', { id });
export const GET_BONDS_PRICE_IRS_HISTORY_SNP_URL = (id) => UrlParamsReplace('/irs-histories/:id/snp', { id });
export const GET_BONDS_PRICE_CURRENCY_HISTORY_SNP_URL = (id) => UrlParamsReplace('/currency-histories/:id/snp', { id });

export const SEND_FORGOT_PASSWORD_EMAIL_URL = UrlParamsReplace('/forgot-password');
export const RESET_USER_PASSWORD = () => UrlParamsReplace('/reset-password');
export const GET_USER_SECTOR_BONDS = (auto) => UrlParamsReplace(`/user-sectors?auto=${auto}`);
export const GET_FXO_VOL_HISTORY = (id) => UrlParamsReplace('/fxo-vol-histories/:id', { id });

export const FX_OPTIONS_CURRENCY = (ticker) => UrlParamsReplace(`/fx-options/currency-pairs/${ticker}`);
export const FX_OPTIONS_CURRENCIES = () => UrlParamsReplace('/fx-options/currency-pairs');
export const FX_OPTIONS_FORWARD_RATE = () => UrlParamsReplace('/fx-options/forward-rate');
export const FX_OPTIONS_EXPIRY_DATE = () => UrlParamsReplace('/fx-options/calculate-expiry-date');
export const DSLICE_GRID = () => UrlParamsReplace('/fx-options/calculate-dslice-grid');

export const GET_UMBRELLA_ORGS = () => UrlParamsReplace('/umbrella-org');
export const UMBRELLA_ORGS = () => UrlParamsReplace('/umbrella-org');
export const MAKE_COMPANY_ADMIN = () => UrlParamsReplace('/umbrella-org/company-admin');

export const GET_UMBRELLA_ORGS_TEAMS = (umbrellaOrgId) => UrlParamsReplace(`/umbrella-org-teams?umbrellaOrgId=${umbrellaOrgId}`);
export const UMBRELLA_ORGS_TEAMS = () => UrlParamsReplace('/umbrella-org-teams');
export const GET_IRS_FORWARDS_HISTORY = (id, legs, plotRange, imm, conversion) => UrlParamsReplace(`/irs-forwards/irs/:id?legs=${legs}&plotUnit=${plotRange?.unit}&plotValue=${plotRange?.value}${imm ? `&imm=${imm}` : ''}${conversion ? `&conversion=${conversion}` : ''}`, { id });
export const GET_IRS_EDGE_URL = ({ id, range }) => UrlParamsReplace(`/irs-edges/irs/:id?range=${range}`, { id });
export const GET_IRS_ANCHOR_URL = ({ id, range }) => UrlParamsReplace('/anchors/irs/:id', { id });
export const GET_IRS_BGC_DATA = (id, days) => UrlParamsReplace('/irs-bgc/:id?days=:days', { id, days });
export const GET_IRS_RC_DETAILS2 = (id, legs, horizons) => UrlParamsReplace(`/irs-rc/forward-rate-2/:id?legs=${legs}${horizons ? `&horizons=${horizons}` : ''}`, { id });

export const GET_IRS_SECURITY_BY_IRS_ID_TERM = ({ irsId, term }) => UrlParamsReplace(
    '/irs-securities?irsId=:irsId&term=:term',
    { irsId, term: encodeURIComponent(term || '') }
);
export const GET_IRS_RC_DETAILS3 = (id, horizons) => UrlParamsReplace(`/irs-rc/forward-rate-3/:id?${horizons ? `horizons=${horizons}` : ''}`, { id });

export const GET_ALL_CURRENCY = () => UrlParamsReplace('/currencies-list');
export const GET_ALL_FXO_CURRENCY = () => UrlParamsReplace('/fxo-list');
export const CREATE_SDR_FILTER = () => UrlParamsReplace('/sdr-filter');
export const SDR_FILTER = (id) => UrlParamsReplace('/sdr-filter/:id', { id });
export const GET_ALL_USER_SDR_FILTER = (category) => UrlParamsReplace(`/sdr-filters?category=${category}`);
export const GET_SDR_TRADE_EXCEL_URL = UrlParamsReplace('/excel/dtcc-trades');
export const UPDATE_SDR_FILTER = (id, category) => UrlParamsReplace(`/user-sdr-filter/:id?category=${category}`, { id });
export const GET_OLDEST_DTCC_TRADE_TIME = (irsId) => {
    const url = irsId ? `/oldest-dtcc-trade-time?irsId=${irsId}` : '/oldest-dtcc-trade-time';
    return UrlParamsReplace(url);
};

export const USER_PREFERENCE = () => UrlParamsReplace('/user-preference');

export const CHRONOS_DV01_SUMAARY = () => UrlParamsReplace('/dv01-summary');
export const CHRONOS_TRADE_LEVEL_SUMAARY = () => UrlParamsReplace('/trade-over-time');
export const CHRONOS_MEETING_DATES = () => UrlParamsReplace('/meeting-dates');

export const GET_ANCHOR_VARIABLES = (id) => UrlParamsReplace('/variable-tenor/:id', { id });

export const GET_REGRESS = () => UrlParamsReplace('/regress');
export const BULK_UPDATE_MEETING_DATES_URL = (id) => UrlParamsReplace('/meeting-dates/bulk-update');
export const GET_IRS_CTA = (data) => UrlParamsReplace(`/cta/irs?debug=${data.debug}`);
export const GET_IRS_CTA_BY_CCY = ({
    ccy, debug = false, history = false, limit = 21
}) => UrlParamsReplace(`/cta/irs/ccy?ccy=${ccy}&debug=${debug}&history=${history}&limit=${limit}`);
